export enum CarrierTableColumnIdentifiers {
    CustomerName = "customerName",
    SPID = "spids",
    LosingCarrierSpid = "losingCarrierSpid",
    Actions = "actions"
}